import AgentCommentsTextField from "../atoms/AgentCommentsTextField";
import AddCommentButton from "../atoms/AddCommentButton";

const CommentEntry = (props) => {
  const {
    textPlaceholderText,
    textValue,
    textOnChange,
    buttonOnClick,
    buttonId,
    buttonText,
  } = props;
  return (
    <div style={{ width: "100%" }}>
      <AgentCommentsTextField
        textPlaceholderText={textPlaceholderText}
        textValue={textValue}
        textOnChange={textOnChange}
      ></AgentCommentsTextField>
      <AddCommentButton
        onClick={buttonOnClick}
        id={buttonId}
        text={buttonText}
      ></AddCommentButton>
    </div>
  );
};

export default CommentEntry;
